import ProgressRing from "./ProgressRing";

// Компактное кольцо прогресса в карточке урока. Три состояния:
// - empty (done=0): тонкий пустой контур без подписи.
// - in-progress: синяя дуга + "X/N" по центру.
// - done: сплошной зелёный круг с белой галочкой.
export default function LessonProgressRing({
  total,
  done,
  pct,
  isDone,
  isEmpty,
}: {
  total: number;
  done: number;
  pct: number;
  isDone: boolean;
  isEmpty: boolean;
}) {
  const SIZE = 52;
  // Нет блоков вообще — место под кольцо держим (чтобы вёрстка карточек не прыгала),
  // но рисуем пустой контур.
  if (total === 0 || isEmpty) {
    return (
      <ProgressRing
        percent={0}
        size={SIZE}
        stroke={3}
        trackColor="var(--card-border)"
      />
    );
  }
  if (isDone) {
    return (
      <div
        className="lesson-ring-done"
        style={{ width: SIZE, height: SIZE }}
        aria-label="Урок пройден"
      >
        <svg width={SIZE} height={SIZE} viewBox={`0 0 ${SIZE} ${SIZE}`}>
          <circle cx={SIZE / 2} cy={SIZE / 2} r={SIZE / 2} fill="#3aa05a" />
          <path
            d={`M${SIZE * 0.3} ${SIZE * 0.52} L${SIZE * 0.45} ${SIZE * 0.68} L${SIZE * 0.72} ${SIZE * 0.36}`}
            fill="none"
            stroke="#fff"
            strokeWidth={3.5}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    );
  }
  return (
    <ProgressRing percent={pct} size={SIZE} stroke={4}>
      <span className="lesson-ring-label">
        {done}/{total}
      </span>
    </ProgressRing>
  );
}
